import JSXComponent from "../../dist/jsx-render/JSXComponent";
import dom from "../../dist/jsx-render/dom";
import { app } from "../Frame/App";

export type AmpelComponentProps = {
    model: any;
    fieldName: string;
    friendlyValueField?: string;
    name: string;
    defaultValue?: number;
    useGrey?: boolean;
    useAuto?: boolean;
    useNone?: boolean;
}

export class AmpelComponent extends JSXComponent {
    props: AmpelComponentProps;
    constructor(props: AmpelComponentProps) { super(props);  }

    clientId: string = app.createRadomizedLetters(10) + "_ampel";

    element: HTMLElement;
    getElement = () => {
        this.element = <div className="ampel-component form-group">
            {this.props.name
                ? <label className="form-label d-block">{this.props.name}</label>
                : []}
            {this.props.useAuto
                ? <div className="form-check form-check-inline">
                    <input className="form-check-input" type="radio" id={this.clientId + "-1"} value="-1" name={this.clientId} />
                    <label className="form-check-label" for={this.clientId + "-1"}>
                        <div className="ampel d-flex justify-content-center align-items-center ampel-auto" style={{ width: "50px" }}>Auto</div>
                    </label>
                </div>
                :[]}
            <div className="form-check form-check-inline">
                <input className="form-check-input" type="radio" id={this.clientId + "0"} value="0" name={this.clientId} />
                <label className="form-check-label" for={this.clientId + "0"}>
                    <div className="ampel ampel-red" />
                </label>
            </div>
            <div className="form-check form-check-inline">
                <input className="form-check-input" type="radio" id={this.clientId + "1"} value="1" name={this.clientId} />
                <label className="form-check-label" for={this.clientId + "1"}>
                    <div className="ampel ampel-yellow" />
                </label>
            </div>
            <div className="form-check form-check-inline">
                <input className="form-check-input" type="radio" id={this.clientId + "2"} value="2" name={this.clientId} />
                <label className="form-check-label" for={this.clientId + "2"}>
                    <div className="ampel ampel-blue" />
                </label>
            </div>
            <div className="form-check form-check-inline">
                <input className="form-check-input" type="radio" id={this.clientId + "3"} value="3" name={this.clientId} />
                <label className="form-check-label" for={this.clientId + "3"}>
                    <div className="ampel ampel-green" />
                </label>
            </div>
            {this.props.useGrey
                ? <div className="form-check form-check-inline">
                    <input className="form-check-input" type="radio" id={this.clientId + "4"} value="4" name={this.clientId} />
                    <label className="form-check-label" for={this.clientId + "4"}>
                        <div className="ampel ampel-onhold" />
                    </label>
                </div>
                : []}
            {this.props.useNone
                ? <div className="form-check form-check-inline">
                    <input className="form-check-input" type="radio" id={this.clientId + "-2"} value="-2" name={this.clientId} />
                    <label className="form-check-label" for={this.clientId + "-2"}>
                        <div className="ampel-none">{Resources.Common.none}</div>
                    </label>
                </div>
                : []}
        </div>
    }

    private getFriendlyAmpelValue = (value: string) => {
        switch (value) {
            case "-1":
                return Resources.Common["ampelAuto"];
            case "0":
                return Resources.Common["ampelRed"];
            case "1":
                return Resources.Common["ampelYellow"];
            case "2":
                return Resources.Common["ampelBlue"];
            case "3":
                return Resources.Common["ampelGreen"];
            case "4":
                return Resources.Common["ampelGrey"];
            default:
                return null;
        }
    }

    private updateModelFromControl = (input: HTMLInputElement) => {
        this.props.model.setPropertyByPath(this.props.fieldName, input.value);
        if (this.props.friendlyValueField) {
            this.props.model.setPropertyByPath(this.props.friendlyValueField, this.getFriendlyAmpelValue(input.value));
        }
    }

    private onChange = (event: Event) => {
        let input = event.target as HTMLInputElement;
        this.updateModelFromControl(input);
    }

    render() {
        this.getElement();

        if (this.props.model[this.props.fieldName] && this.validateValue(this.props.model[this.props.fieldName])) {
            let selectedValueInput = this.element.querySelector(`#${this.clientId + (this.props.model[this.props.fieldName] as string)}`) as HTMLInputElement;
            selectedValueInput.checked = true;
        }

        let inputs = this.element.querySelectorAll("input");
        inputs.forEach(i => i.addEventListener("change", this.onChange));

        return this.element;
    }

    private validateValue = (value: string) => {
        if (value == "-1" || value == "0" || value == "1" || value == "2" || value == "3" || value == "4") return true;
        return false;
    }
}
